import { Auth0Provider } from '@auth0/auth0-react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import { AUDIENCE_JWT } from 'utils/constants';

import App from './App';
import * as serviceWorker from './serviceWorker';
import getConfig from './utils/getAuthConfig';
import history from './utils/history';

const onRedirectCallback = (appState) => {
  history.push(
    appState && appState.returnTo ? appState.returnTo : window.location.pathname
  );
};

// Please see https://auth0.github.io/auth0-react/interfaces/auth0_provider.auth0provideroptions.html
// for a full list of the available properties on the provider
const config = getConfig();

const providerConfig = {
  domain: config.domain,
  clientId: config.clientId,
  ...(config.audience ? { audience: config.audience } : null),
  redirectUri: window.location.origin,
  onRedirectCallback,
  audience: AUDIENCE_JWT
};

ReactDOM.render(
  <Auth0Provider {...providerConfig}>
    <BrowserRouter>
      <RecoilRoot>
        <App />
      </RecoilRoot>
    </BrowserRouter>
  </Auth0Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
